module.exports = __webpack_public_path__ + "static/img/content3.9ceb207a.png";